// istanbul ignore file
// Todo(steve): This file will be removed in the future.
import { hooks } from "./internal/Runtime.js";

/** @deprecated import it from "@next-core/easyops-runtime" instead */
export function authenticate() {
  var _hooks$auth, _hooks$auth$authentic;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  hooks === null || hooks === void 0 || (_hooks$auth = hooks.auth) === null || _hooks$auth === void 0 || (_hooks$auth$authentic = _hooks$auth.authenticate) === null || _hooks$auth$authentic === void 0 || _hooks$auth$authentic.call(_hooks$auth, ...args);
}

/** @deprecated import it from "@next-core/easyops-runtime" instead */
export function getAuth() {
  var _hooks$auth2;
  return hooks === null || hooks === void 0 || (_hooks$auth2 = hooks.auth) === null || _hooks$auth2 === void 0 ? void 0 : _hooks$auth2.getAuth();
}

/** @deprecated import it from "@next-core/easyops-runtime" instead */
export function logout() {
  var _hooks$auth3, _hooks$auth3$logout;
  return hooks === null || hooks === void 0 || (_hooks$auth3 = hooks.auth) === null || _hooks$auth3 === void 0 || (_hooks$auth3$logout = _hooks$auth3.logout) === null || _hooks$auth3$logout === void 0 ? void 0 : _hooks$auth3$logout.call(_hooks$auth3);
}

/** @deprecated import it from "@next-core/easyops-runtime" instead */
export function isLoggedIn() {
  var _hooks$auth4;
  return hooks === null || hooks === void 0 || (_hooks$auth4 = hooks.auth) === null || _hooks$auth4 === void 0 ? void 0 : _hooks$auth4.isLoggedIn();
}
//# sourceMappingURL=auth.js.map